import '.a{display:flex;}.ssr-plugin'
import '.el{gap:2rem;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.d{gap:1rem;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { FaqItem } from './FaqItem'
import useMediaQuery from '@app/util/useMediaQuery'
import { AppearItem } from '@app/components/blocks/contentSection/blocks/AppearInViewport'

export type FaqSectionItem = {
  question: string
  answer: string
}

export type FaqSectionProps = {
  items: ReadonlyArray<FaqSectionItem>
  title: string
  subtitle?: string
}

const FaqSection = ({ items, title, subtitle }: FaqSectionProps) => {
  const isMobile = useMediaQuery()

  return (
    <div className="a el"
      style={{
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'stretch' : 'center',}}
    >
      <div className="a b d t"
        style={{
          width: isMobile ? '100%' : '45%',}}
      >
        <AppearItem staggerIndex={0}>
          <Title.H2 style={{ marginBottom: 0 }}>{title}</Title.H2>
        </AppearItem>
        {subtitle && (
          <AppearItem staggerIndex={1}>
            <Text.Medium>{subtitle}</Text.Medium>
          </AppearItem>
        )}
      </div>
      <div
        style={{
          width: isMobile ? '100%' : '55%',
        }}
      >
        {items.map((item, index) => (
          <AppearItem key={item.question} staggerIndex={index + 2}>
            <FaqItem question={item.question} answer={item.answer} />
          </AppearItem>
        ))}
      </div>
    </div>
  )
}

export default FaqSection
